import React from 'react';

const KmContent = ({ garrison }) => {
    if (!garrison?.kmcontrol) return null;

    let total = 'Inconsistente';
    const initial = garrison?.initialmileage ?? '';
    const final = garrison?.finalmileage ?? '';
    if (initial && final && parseInt(final) >= parseInt(initial)) total = final - initial;

    return (
        <tr>
            <th className={'journal-label'}>Km inicial:</th>
            <td>
                <div className="km-inline transform -translate-x-[40px]">
                    {initial || '0'} km

                    <span className="km-label">Km final:</span>
                    {final || '0'} km
                </div>
            </td>

            <th className={'journal-label'}>Km percorrido:</th>
            <td className={'transform -translate-x-[5px]'}>{total === 'Inconsistente' ? total : `${total} km`}</td>
        </tr>
    );
}

export default KmContent;